import { c as _c } from "react/compiler-runtime";
import { IcoShield24 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
type SsnDisclaimerProps = {
  variant: 'ssn4' | 'ssn9' | 'usTaxId';
};
export const SsnDisclaimer = t0 => {
  const $ = _c(16);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== t || $[2] !== variant) {
    t2 = () => {
      if (variant === "usTaxId") {
        return t(_temp);
      }
      if (variant === "ssn9") {
        return t(_temp2);
      }
      return t(_temp3);
    };
    $[1] = t;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getDescription = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoShield24 color="primary" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp4);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-label-2 text-primary">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getDescription) {
    t6 = getDescription();
    $[9] = getDescription;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <span className="text-body-2 text-secondary">{t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <section aria-label="disclaimer" className="flex gap-3 p-4 bg-secondary rounded-lg w-full">{t3}<div className="flex flex-col gap-1">{t5}{t7}</div></section>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp($) {
  return $.fields.ssn.disclaimer.usTaxId;
}
function _temp2($_0) {
  return $_0.fields.ssn.disclaimer.ssn9;
}
function _temp3($_1) {
  return $_1.fields.ssn.disclaimer.ssn4;
}
function _temp4($_2) {
  return $_2.fields.ssn.disclaimer.title;
}